'use strict';

var typedText = '';
var typingTimeout;

/**
 * Scrolls a parent element to bring a child element into view. If the child
 * is out of view, it will animate the parent element's scrollTop position to
 * bring the child into view, centered in the parent if possible.
 *
 * @param {jQuery} parentElement - The parent element to scroll.
 * @param {jQuery} child - The child element to bring into view.
 */
function scrollToElement(parentElement, child) {
    if (child.length) {
        let childPosition = child.position().top + parentElement.scrollTop();
        let parentHeight = parentElement.innerHeight();

        // Check if the element is out of view
        if (childPosition < parentElement.scrollTop()
            || childPosition + child.outerHeight() > parentElement.scrollTop() + parentHeight) {
            // Scroll the parent to bring the child into view
            parentElement.animate({ scrollTop: childPosition - parentHeight / 2 }, 300);
        }
    }
}

/**
 * Resets the state of the dropdown's search feature when the dropdown is
 * hidden. This removes any currently highlighted options and clears the
 * search text.
 *
 * @param {jQuery} optionsDiv - The dropdown's options container element.
 */
function resetSearchOnDropdownHide(optionsDiv) {
    typedText = '';
    clearTimeout(typingTimeout);
    optionsDiv.find('.py-option-value.focused').removeClass('focused');
}

/**
 * Highlights the nearest matching option in the dropdown list when the user
 * types into the search text input. If the typed text matches the beginning of
 * an option value, that option is highlighted and scrolled into view if
 * necessary. If the typed text does not match any options, all options are
 * unhighlighted.
 *
 * @param {string} text - The text entered by the user in the search input.
 * @returns {boolean} false to prevent the default keydown handler from
 *          executing.
 */
function highlightNearestMatch(text) {
    let visibleDropdown = $('.py-option-values.show');
    let listItems = visibleDropdown.find('li.py-option-value');

    if (text.length === 0) {
        listItems.removeClass('focused');
        return false;
    }

    let found = false;
    let matchedOption = listItems.filter(function () {
        return $(this).attr('value').toLowerCase().startsWith(text);
    }).first();

    listItems.removeClass('focused');

    if (matchedOption.length) {
        scrollToElement(visibleDropdown, matchedOption);
        matchedOption.addClass('focused');
        found = true;
        return true;
    }

    if (!found) {
        listItems.removeClass('focused');
    }
    return true;
}

$(document).click(function (event) {
    if (!$(event.target).is('.py-custom-select-div, .py-custom-select-div *')) {
        let parentEle = $('.py-custom-select-div');
        let optionsDiv = parentEle.find('.py-option-values');
        let icon = parentEle.find('.py-dropdown-icon');
        icon.removeClass('rotate');
        optionsDiv.removeClass('show');
        resetSearchOnDropdownHide(optionsDiv);
    }
});

$(document).on('click', '.py-dropdown-icon, .py-custom-select-input', function () {
    let $this = $(this);
    let parentEle = $this.closest('.py-custom-select-div');
    let optionsDiv = parentEle.find('.py-option-values');
    var otherOptions = $('.py-option-values.show').not(optionsDiv);
    if (otherOptions.length > 0) {
        otherOptions.removeClass('show');
        otherOptions.parent().find('.py-dropdown-icon').toggleClass('rotate');
        resetSearchOnDropdownHide(otherOptions);
    }

    let icon = parentEle.find('.py-dropdown-icon');
    icon.toggleClass('rotate');
    optionsDiv.toggleClass('show');
    resetSearchOnDropdownHide(optionsDiv);
});

$(document).on('click', '.py-option-value', function () {
    let $this = $(this);
    let parentEle = $this.closest('.py-custom-select-div');
    let traditionalSelect = parentEle.prev().find('select');
    let inputEle = parentEle.find('.py-custom-select-input');
    let icon = parentEle.find('.py-dropdown-icon');
    let optionValues = parentEle.find('.py-option-values');

    $this.siblings('.selected').removeClass('selected');
    let isDisabled = $this.attr('disabled');
    if (isDisabled) return;
    $this.addClass('selected');
    if (parentEle.hasClass('type-inputandimage')) {
        let img = $this.find('img');
        let label = parentEle.find('.py-custom-select-label');
        const clonedImage = img.clone();
        label.empty().append(clonedImage);
    }
    let keyAttribute = $this.attr('data-value');
    let prevValue = traditionalSelect.find('option:selected');
    if (prevValue) {
        prevValue.removeAttr('selected');
    }
    let selectedValue = traditionalSelect.find('option[data-value="' + keyAttribute + '"]');
    selectedValue.attr('selected', 'selected');
    traditionalSelect.val(selectedValue.val());
    inputEle.val(selectedValue.val());
    if (parentEle.hasClass('type-manipulate-input')) {
        inputEle.val(keyAttribute);
    } else {
        inputEle.val(selectedValue.val());
    }
    icon.toggleClass('rotate');
    optionValues.toggleClass('show');
    resetSearchOnDropdownHide(optionValues);
    traditionalSelect.trigger('change');
});

$(document).on('keydown', function (event) {
    if ($('.py-option-values').hasClass('show')) {
        let key = event.key.toLowerCase();

        if (/^[a-z]$/.test(key)) {
            typedText += key;
        } else if (event.key === 'Backspace') {
            typedText = typedText.slice(0, -1);
        } else if (event.key === 'Enter') {
            let focusedElement = $('li.py-option-value.focused');
            if (focusedElement.length) {
                focusedElement.trigger('click');
            }
            return;
        } else {
            return;
        }

        clearTimeout(typingTimeout);
        typingTimeout = setTimeout(() => {
            typedText = '';
            $('li.py-option-value').removeClass('focused');
        }, 2000);

        highlightNearestMatch(typedText);
    }
});
